<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.3215 11.017L11.9715 0.667C11.5575 0.253 10.9825 0 10.35 0H2.3C1.035 0 0 1.035 0 2.3V10.35C0 10.9825 0.253 11.5575 0.6785 11.983L11.0285 22.333C11.4425 22.747 12.0175 23 12.65 23C13.2825 23 13.8575 22.747 14.2715 22.3215L22.3215 14.2715C22.747 13.8575 23 13.2825 23 12.65C23 12.0175 22.7355 11.431 22.3215 11.017ZM4.025 5.75C3.0705 5.75 2.3 4.9795 2.3 4.025C2.3 3.0705 3.0705 2.3 4.025 2.3C4.9795 2.3 5.75 3.0705 5.75 4.025C5.75 4.9795 4.9795 5.75 4.025 5.75Z"
      fill="#495057"
    />
    <path
      d="M6.24467 10.042L13.191 13.2663L9.8128 6.3986L11.6973 4.47432L18.8083 11.4384L17.3686 12.9085L15.4248 11.0048L12.213 7.57237L15.6324 14.6813L14.6471 15.6874L7.47797 12.4171L10.9718 15.5518L12.9156 17.4554L11.4807 18.9206L4.36973 11.9565L6.24467 10.042Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconBreed',
  props: {
    width: {
      type: Number,
      default: 23,
    },
    height: {
      type: Number,
      default: 23,
    },
  },
};
</script>

<style scoped>
</style>